<template>
  <!-- modal information user -->
    <div class="modal fade" id="modal-information-user" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header" style="text-align:center">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h3 v-if="userId > 0" class="modal-title">{{$t('user.profile')}}</h3>
            <h3 v-if="customerId > 0" class="modal-title">{{$t('customer.profile')}}</h3>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <b>{{$t('common.code')}}:</b> {{userdata.code}}<br>
                <!-- /code -->
                <b>{{$t('user.fullname')}}:</b> {{userdata.full_name}}<br>
                <!-- /fullname -->
                <b>{{$t('user.gender')}}:</b> {{this.$t(this.getGender(userdata.gender))}}<br>
                <!-- /gender -->
                <b>{{$t('user.dob')}}:</b> {{userdata.dob}}<br>
                <!-- /dob -->
              </div>
              <div class="col-md-6 col-lg-6">
                <b>{{$t('user.username')}}:</b> {{userdata.username}}<br>
                <!-- /username -->
                <b>{{$t('user.phone')}}:</b> {{userdata.phone}}<br>
                <!-- /phone -->
                <b>{{$t('user.email')}}:</b> {{userdata.email}}<br>
                <!-- /email -->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-right"
              data-dismiss="modal"
            >{{$t('common.close')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  <!-- /.modal -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import constantsData from '../lib/constantsData';
import utils from "@/lib/utils";

export default {
  name: 'InformationUserModal',
  props: {
    userId: {
      type: Number,
      default: () => { return 0 }
    },
    customerId: {
      type: Number,
      default: () => { return  0 }
    }
  },
  data () {
    return {
      userdata: {
        username: "",
        first_name: "",
        last_name: "",
        full_name: "",
        email: "",
        dob: "",
        phone: "",
        gender: "Nam",
        code: ""
      },
      gender_list: constantsData.genderTypes,
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false,
      }
    }
  },
  watch: {
    userId: function() {
      if (this.userId > 0) {
        this.GET_USER_DETAIL({ id: this.userId });
      }
    },
    customerId: function() {
      if (this.customerId > 0) {
        this.GET_CUSTOMER_DETAIL({ id: this.customerId });
      }
    },
    // watch user detail
    USER_DETAIL_DATA: function() {
      this.bindData(this.USER_DETAIL_DATA)
    },
    // watch customer detail
    CUSTOMER_DETAIL_DATA: function () {
      this.bindData(this.CUSTOMER_DETAIL_DATA)
    }
  },
  computed: {
    ...mapGetters([
      "USER_DETAIL_DATA",
      "CUSTOMER_DETAIL_DATA"
    ])
  },
  components: {
  },
  methods: {
    ...mapActions([
      "GET_USER_DETAIL",
      "GET_CUSTOMER_DETAIL"
    ]),
    getGender(gender) {
      return utils.getGender(gender)
    },
    bindData: function(data) {
      this.userdata.username = data.username
      this.userdata.email = data.email
      this.userdata.first_name = data.first_name
      this.userdata.last_name = data.last_name
      if (data.profile) {
        this.userdata.phone = data.profile.phone
        this.userdata.dob = utils.formatSqlDate(data.profile.dob, null, this.options.format)
        this.userdata.gender = data.profile.gender
        this.userdata.code = data.profile.code
      }
      this.userdata.full_name = `${data.last_name} ${data.first_name}`
    }
  },
  mounted() {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/InformationUserModal.vue